import React from 'react';
import { howItWorks, appFeatures } from '../mock';
import Reveal from './Reveal';

const HowItWorks = () => {
  return (
    <section id="how" className="py-24 bg-[#16161B] border-y border-white/5 relative">
      <div className="container-ydd">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <span className="text-[var(--ydd-yellow)] font-semibold text-sm uppercase tracking-widest">How it works</span>
            <h2 className="font-display text-white text-3xl md:text-5xl mt-4 leading-tight">Three simple steps</h2>
            <p className="text-gray-400 mt-4 text-lg">Stay informed and start saving in minutes.</p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 mt-14">
          {howItWorks.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.step} delay={i * 120}>
                <div className="card-ydd p-8 h-full relative">
                  <span className="font-display text-[3.5rem] leading-none text-white/5 absolute top-4 right-5 select-none">{s.step}</span>
                  <div className="h-14 w-14 rounded-2xl bg-[var(--ydd-yellow)] flex items-center justify-center">
                    <Icon size={26} className="text-[#0E0E11]" />
                  </div>
                  <h3 className="text-white font-bold text-xl mt-6">{s.title}</h3>
                  <p className="text-gray-400 mt-3 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* Features grid */}
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mt-24">
            <span className="text-[var(--ydd-yellow)] font-semibold text-sm uppercase tracking-widest">The experience</span>
            <h2 className="font-display text-white text-3xl md:text-4xl mt-4 leading-tight">Fast, simple &amp; delightful</h2>
          </div>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
          {appFeatures.map((f, i) => {
            const Icon = f.icon;
            return (
              <Reveal key={f.title} delay={(i % 3) * 90}>
                <div className="group rounded-2xl border border-white/8 bg-[#1B1B21] p-6 hover:border-[var(--ydd-yellow)]/40 transition-colors duration-300 h-full">
                  <div className="h-11 w-11 rounded-xl bg-white/5 flex items-center justify-center group-hover:bg-[var(--ydd-yellow)] transition-colors duration-300">
                    <Icon size={20} className="text-[var(--ydd-yellow)] group-hover:text-[#0E0E11] transition-colors duration-300" />
                  </div>
                  <h3 className="text-white font-semibold text-base mt-4">{f.title}</h3>
                  <p className="text-gray-400 text-sm mt-2 leading-relaxed">{f.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
